import React, { useEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "lucide-react";

const Dropdown = ({ label, options, onSelect, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    if (!disabled) {
      // Only toggle if not disabled
      setIsOpen(!isOpen);
    }
  };

  const handleOptionSelect = (option) => {
    if (!disabled) {
      // Only select if not disabled
      onSelect(option);
      setIsOpen(false);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative flex justify-end" ref={dropdownRef}>
      <button
        type="button"
        className="flex items-center justify-between w-full px-4 py-2 text-sm font-medium text-white bg-black/20 input h-9 rounded-md shadow-sm focus:outline-none"
        onClick={toggleDropdown}
        disabled={disabled}
      >
        {label}
        <ChevronDownIcon
          className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
            isOpen ? "transform rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute top-10 z-10 mt-2 w-full max-h-64 overflow-y-auto bg-black/90 text-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {options?.map((option, index) => (
              <div
                key={index}
                className="block px-4 py-2 text-sm text-white hover:bg-gray-100 hover:text-gray-900"
                onClick={() => handleOptionSelect(option)}
              >
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
